/* eslint-disable @typescript-eslint/no-explicit-any */
import { getLocaleFromUrl } from '../services/instance.service';
import { appInstance } from '../../modules/config/constants';
import {
  getFlowAndPartnerByPath,
  getPageNameAndVerticalByPath,
  getUrl,
} from './path-mapper.util';
import { NextRequest, userAgent } from 'next/server';

/*  TODO: urlMap on frontend-shared was ref by @client(country-instance)
let's keep it as a param any and thing a way to change it in the future */

export const getPageDataFromUrl = (request: NextRequest, utmSource: string, urlMap: any) => {
  const url = request.nextUrl;
  const locale = getLocaleFromUrl(url.pathname, appInstance) || 'en';
  const pathname = url.pathname;
  const { pageName, vertical } = getPageNameAndVerticalByPath(pathname, urlMap);
  const flowDetails = getFlowAndPartnerByPath(url.pathname, urlMap);
  const { flow } = (flowDetails as Record<string, string>) || {};
  let redirectUrl = getUrl(
    pageName,
    vertical,
    locale,
    flow,
    utmSource,
    {},
    url.origin,
    urlMap
  );
  if (redirectUrl) redirectUrl = redirectUrl.replace(url.origin, '');
  const redirectFlowDetails = getFlowAndPartnerByPath(redirectUrl, urlMap);
  const { partner } = (redirectFlowDetails as Record<string, string>) || {};
  const { device } = userAgent(request);
  const viewport =
    device.type === 'mobile' || device.type === 'tablet' ? 'mobile' : 'desktop';

  return {
    pageName,
    vertical,
    locale,
    flow,
    redirectUrl,
    partner,
    device,
    viewport,
  };
};

export const getPageFromPath = (path: string, urlMap: any) =>
  getPageNameAndVerticalByPath(path, urlMap);
